import React, { useState, useEffect, useRef } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { validaSoloNumero } from "../../util/varios";
import { Search } from "@material-ui/icons";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { GestionarFiscales } from "./modalFIscales";
import { GestionarProcedimiento } from "./modalProcedimiento";
import CatalogoAgenteTipo from "../../catalogos/catalogoAgenteTipo";

const ProcedFiscal = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let el;
  const chk1 = useRef();
  const chk2 = useRef();
  const txtFiscal = useRef();
  const txtAgente = useRef();
  const txtRifAgente = useRef();
  const txtRifFiscal = useRef();
  const txtProcedimiento = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [mostrarCatalogo, setMostrarCatalogo] = useState();
  const [tipo, setTipo] = useState();
  const [nombre, setNombre] = useState("Agente");
  function menuclick() {
    if ((el = document.getElementById("wrapper"))) {
      el.classList.add("toggled");
    }
  }

  const modalProc = () => {
    /* if(!mostrar){
      setMostrar(true)
    } else {
      setMostrar(false)
    } */
  };

  const datosRes = (rif) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${rif}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let e = response.data;
          if (response.data !== "") {
            if (tipo === 2) {
              txtRifFiscal.current.value = e.rif;
              txtFiscal.current.value =
                "Nombre: " +
                e.nombre +
                ", " +
                "Direccion: " +
                e.direccion +
                ", " +
                "N° Licencia: " +
                e.nrolicencia;
            } else if (tipo === 3 || tipo === 4) {
              txtRifAgente.current.value = e.rif;
              txtAgente.current.value =
                "Nombre: " +
                e.nombre +
                ", " +
                "Direccion: " +
                e.direccion +
                ", " +
                "N° Licencia: " +
                e.nrolicencia;
            }
          } else {
            blanquear();
          }
        }
      })
      .catch(function (error) {
        /*         setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' }); */
      });
  };

  const validarRifAgente = (tipo) => (event) => {
    setTipo(tipo);
    event.preventDefault();
    /*     validaSoloNumero(event); */
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosRes(event.target.value);
      } else {
        blanquear();
      }
    }
  };

  const validarFiscal = (tipo) => (e) => {
    e.preventDefault();
    setTipo(tipo);
    catalogo();
  };

  const validarAgente = (tipo, nombre) => (e) => {
    e.preventDefault;
    setTipo(tipo);
    setNombre(nombre);
    (txtAgente.current.value = ""), (txtRifAgente.current.value = "");
  };

  const catalogo = () => {
    if (!mostrarCatalogo) {
      setMostrarCatalogo(true);
    } else {
      setMostrarCatalogo(false);
    }
  };

  const catalogo2 = () => {
    if (tipo === 4 || tipo === 3) {
      if (!mostrarCatalogo) {
        setMostrarCatalogo(true);
      } else {
        setMostrarCatalogo(false);
      }
    } else {
      setMostrarCatalogo(false);
      chk1.current.focus();
    }
  };

  const llenarInformacion = (id, nomb, status, direccion, nre, nli, rif) => {
    seleccionarRegistro(id);
  };

  const seleccionarRegistro = (id) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    /*     setActivate(true); */

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          let e = response.data;
          if (response.data.idagente > 0) {
            if (tipo === 2) {
              txtRifFiscal.current.value = e.rif;
              txtFiscal.current.value =
                "Nombre: " +
                e.nombre +
                ", " +
                "Direccion: " +
                e.direccion +
                ", " +
                "N° Licencia: " +
                e.nrolicencia;
            } else if (tipo === 3 || tipo === 4) {
              txtRifAgente.current.value = e.rif;
              txtAgente.current.value =
                "Nombre: " +
                e.nombre +
                ", " +
                "Direccion: " +
                e.direccion +
                ", " +
                "N° Licencia: " +
                e.nrolicencia;
            }
          }
        }
      })
      .catch((error) => {
        /*    setActivate(false); */
      });
  };

  const blanquear = () => {
    txtRifFiscal.current.value = "";
    txtRifAgente.current.value = "";
    txtFiscal.current.value = "";
    txtAgente.current.value = "";
    txtFiscal.current.value = "";
    txtProcedimiento.current.value = "";
    chk1.current.checked = false;
    chk2.current.checked = false;
  };
  useEffect(() => {}, []);

  return (
    <div>
      <div className="row px-4">
        <div className="col-md-6 py-3 h-100">
          <div className="card mx-auto h-90">
            <div className="card-header text-center">
              <h3>Apertura de Procedimiento</h3>
            </div>
            <div className="card-body ">
              <label>Datos del Fiscal</label>

              <div className="input-group input-group-sm py-1 col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Fiscal:
                </label>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  ref={txtRifFiscal}
                  onKeyUp={validarRifAgente(2)}
                />
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={validarFiscal(2)}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>

              <div className="input-group input-group-sm py-1 col-sm-12">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Informcion del Fiscal:
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  style={{ height: "50px" }}
                  ref={txtFiscal}
                />
              </div>

              <hr className="py-0" />
              <div className="col-md-12 row d-flex justify-content-center">
                <div className="form-check col-md-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    onClick={validarAgente(3, "Entes")}
                    ref={chk1}
                  />
                  <label
                    className="form-check-label py-1"
                    htmlFor="flexRadioDefault1"
                  >
                    {" "}
                    Entes{" "}
                  </label>
                </div>
                <div className="form-check col-md-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    onClick={validarAgente(4, "Expendedor")}
                    ref={chk2}
                  />
                  <label
                    className="form-check-label py-1"
                    htmlFor="flexRadioDefault1"
                  >
                    {" "}
                    Expendedor{" "}
                  </label>
                </div>
              </div>
              <div className="input-group input-group-sm py-1 col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  {nombre}:
                </label>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  ref={txtRifAgente}
                  onKeyUp={validarRifAgente(tipo)}
                />
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={catalogo2}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>

              <div className="input-group input-group-sm py-1 col-sm-12">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Informcion del {nombre}:
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  style={{ height: "50px" }}
                  ref={txtAgente}
                />
              </div>

              <hr className="py-0" />
              <label>Informacion del Procedimiento</label>

              <textarea
                type="text"
                className="form-control h-100"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                style={{ height: "70px" }}
                ref={txtProcedimiento}
              />
            </div>
            <div className="card-footer text-muted d-flex justify-content-end">
              <button
                type="button"
                className="mx-1 btn btn-sm btn-primary rounded-pill"
              >
                Aceptar
              </button>
              <button
                type="button"
                className="mx-1 btn btn-sm btn-danger rounded-pill"
                onClick={blanquear}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-6 py-3 h-100">
          <div className="card mx-auto h-90">
            <div className="card-header text-center">
              <h3>Procedimientos Activos</h3>
            </div>
            <div className="card-body ">
              <table className="table">
                <thead>
                  <tr>
                    <th className="text-center" scope="col">
                      N° Procedimiento
                    </th>
                    <th className="text-center" scope="col">
                      Fiscal
                    </th>
                    <th className="text-center" scope="col">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">7646</td>
                    <td className="text-center">Lc. Pedro Perez</td>
                    <td className="text-center">
                      <button
                        onClick={modalProc}
                        className="btn btn-sm mx-1 btn-info rounded-circle"
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <button
                        onClick={modalProc}
                        className="btn btn-sm mx-1 btn-warning rounded-circle"
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <button
                        onClick={modalProc}
                        className="btn btn-sm mx-1 btn-danger rounded-circle"
                      >
                        <i className="fa fa-trash"></i>{" "}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card-footer text-muted d-flex justify-content-end"></div>
          </div>
        </div>
      </div>
      <GestionarProcedimiento
        show={mostrar}
        onHideCancela={modalProc}
        expendedor={""}
      />
      <CatalogoAgenteTipo
        show={mostrarCatalogo}
        onHideAceptaCatAge={llenarInformacion}
        onHideCancelaCatAge={catalogo}
        tipo={tipo}
      />
    </div>
  );
};
export default ProcedFiscal;



// WEBPACK FOOTER //
// ./src/components/fiscales/regProcedFiscal.js